import { segmentReset } from 'libs/segment/segment';

import { clearTokensStorage } from './tokenStorage';

export const logout = async (): Promise<void> => {
  clearTokensStorage();
  await segmentReset();
};
